import React, { memo } from 'react';
import AppLink from '../../../../components/AppLink';
import BrowserLink from '../../../../components/BrowserLink';
import './FeaturedCard.scss';

export const FeaturedCard = memo(function Card({
  data: { img, url, react_route },
  ...props
}) {

  const wrapperClasses = 'FeaturedCard';
  const content = (
    <div {...props}>
      <div className="FeaturedCard__image-block">
        <img src={img} alt="" />
      </div>
    </div>
  );

  if(react_route) {
    return (
      <AppLink to={react_route} className={wrapperClasses}>
        {content}
      </AppLink>
    );
  }

  if(url) {
    return (
      <BrowserLink href={url} className={wrapperClasses}>
        {content}
      </BrowserLink>
    );
  }
});
